import { selectAccountId } from 'shared/store/modules/accounts/selectors';
import {
  calculateCardFeeRequest,
  calculateCardFeeResponse,
  customerFetchError,
  customerFetchRequest,
  customerFetchResponse,
  customerGetBalance,
  customerGetBilling,
  customerUpdateRequest,
  customerUpdateResponse,
  fetchFeeScheduleRequest,
  fetchFeeScheduleResponse,
  fetchCustomerEstimatedSavingsRequest,
  fetchCustomerEstimatedSavingsResponse,
  customerGetProvisionalSubscriptionRequest,
  customerGetProvisionalSubscriptionResponse,
  customerStartStripeCheckoutRequest,
  customerStartStripeCheckoutResponse,
  customerCompleteStripeCheckoutRequest,
  customerCompleteStripeCheckoutResponse,
  customercreatePaymentIntentsRequest,
  customercreatePaymentIntentsResponse,
  customerCheckDuplicatePaymentMethodRequest,
  customerCheckDuplicatePaymentMethodResponse,
  customerCreateSetupIntentsRequest,
  customerCreateSetupIntentsResponse
} from 'shared/store/modules/customers/actions';

export const updateCustomer = (id, updates) => async (dispatch, _getState, { api }) => {
  dispatch(customerUpdateRequest());

  try {
    await api.subscriber.updateCustomer(id, updates);
    return dispatch(customerUpdateResponse());
  } catch (err) {
    return dispatch(customerUpdateResponse(err));
  }
};

export const fetchCustomer = customerId => async (dispatch, _getState, { api }) => {
  dispatch(customerFetchRequest());

  try {
    const { data: customer } = await api.subscriber.getCustomer(customerId);
    return dispatch(customerFetchResponse(customer));
  } catch (err) {
    return dispatch(customerFetchResponse(err));
  }
};

export const calculateCardFee = amount => async (dispatch, _getState, { api }) => {
  dispatch(calculateCardFeeRequest());
  try {
    const { data } = await api.payment.getCardFee(amount);
    return dispatch(calculateCardFeeResponse(data));
  } catch (err) {
    return dispatch(calculateCardFeeResponse(err));
  }
};

export const fetchFeeSchedule = () => async (dispatch, _getState, { api }) => {
  dispatch(fetchFeeScheduleRequest());
  try {
    const { data } = await api.payment.getFeeSchedule();
    return dispatch(fetchFeeScheduleResponse(data));
  } catch (err) {
    return dispatch(fetchFeeScheduleResponse(err));
  }
};

export const fetchProvisionalSubscription = () => async (dispatch, getState, { api }) => {
  const customerId = selectAccountId(getState());
  dispatch(customerGetProvisionalSubscriptionRequest());

  try {
    const { data } = await api.subscriber.getProvisionalSubscriptionInfo(customerId);
    return dispatch(customerGetProvisionalSubscriptionResponse(data));
  } catch (err) {
    return dispatch(customerFetchError(err));
  }
};

export const getCustomerBilling = id => async (dispatch, getState, { api }) => {
  try {
    const customerId = selectAccountId(getState()) || id;
    const { data } = await api.subscriber.getCustomerBilling(customerId);
    return dispatch(customerGetBilling(data));
  } catch (err) {
    return dispatch(customerFetchError(err));
  }
};

export const getCustomerBalance = id => async (dispatch, getState, { api }) => {
  try {
    const customerId = selectAccountId(getState()) || id;
    const { data } = await api.subscriber.getCustomerBalance(customerId);
    return dispatch(customerGetBalance(data));
  } catch (err) {
    return dispatch(customerFetchError(err));
  }
};

export const fetchCustomerSavings = subscriptionId => async (dispatch, getState, { api }) => {
  dispatch(fetchCustomerEstimatedSavingsRequest());

  const customerId = selectAccountId(getState());

  try {
    const { data } = await api.subscriber.getCustomerEstimatedSavings(customerId, subscriptionId);
    return dispatch(fetchCustomerEstimatedSavingsResponse(data));
  } catch (err) {
    return dispatch(fetchCustomerEstimatedSavingsResponse(err));
  }
};

export const startStripeCheckout = (customerId, amount, invoiceIds) => async (dispatch, _getState, { api }) => {
  dispatch(customerStartStripeCheckoutRequest());
  try {
    const response = await api.payment.createStripeCustomerSession(customerId, amount, invoiceIds);
    return dispatch(customerStartStripeCheckoutResponse(response.data));
  } catch (error) {
    return dispatch(customerStartStripeCheckoutResponse(error));
  }
};

export const checkStripeDuplicatePaymentMethod = confirmationToken => async (dispatch, getState, { api }) => {
  const customerId = selectAccountId(getState());
  dispatch(customerCheckDuplicatePaymentMethodRequest());
  try {
    const response = await api.payment.checkStripeDuplicatePaymentMethod(customerId, confirmationToken);
    return dispatch(customerCheckDuplicatePaymentMethodResponse(response.data));
  } catch (error) {
    return dispatch(customerCheckDuplicatePaymentMethodResponse(error));
  }
};

export const createPaymentIntents = (paymentSourceId, amount, customerId, invoiceIds) => async (
  dispatch,
  _getState,
  { api }
) => {
  dispatch(customercreatePaymentIntentsRequest());
  try {
    const response = await api.payment.createPaymentIntents(paymentSourceId, amount, customerId, invoiceIds);
    return dispatch(customercreatePaymentIntentsResponse(response.data));
  } catch (error) {
    return dispatch(customercreatePaymentIntentsResponse(error));
  }
};

export const completeStripeCheckout = (
  customerId,
  paymentSourceId,
  paymentIntentId,
  invoiceIds,
  amount,
  shouldSavePaymentSource,
  sourceType,
  cardType
) => async (dispatch, _getState, { api }) => {
  dispatch(customerCompleteStripeCheckoutRequest());
  try {
    const response = await api.payment.completeStripePaymentIntent(
      customerId,
      paymentSourceId,
      paymentIntentId,
      invoiceIds,
      amount,
      shouldSavePaymentSource,
      sourceType,
      cardType
    );
    return dispatch(customerCompleteStripeCheckoutResponse(response.data));
  } catch (error) {
    return dispatch(customerCompleteStripeCheckoutResponse(error));
  }
};

export const createSetupIntents = () => async (dispatch, getState, { api }) => {
  const customerId = selectAccountId(getState());
  dispatch(customerCreateSetupIntentsRequest());
  try {
    const response = await api.subscriber.createSetupIntents(customerId);
    return dispatch(customerCreateSetupIntentsResponse(response));
  } catch (err) {
    return dispatch(customerCreateSetupIntentsResponse(err));
  }
};
